import styled from 'styled-components';

export const LargeTagC = styled.span`
  background-color: ${props => props.color};
  color: var(--BackgroundColor);
  display: inline-block;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  padding: 6px 6px;
`;
